var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 0H2.00049C0.900488 0 0.0104883 0.9 0.0104883 2L0.000488281 14C0.000488281 15.1 0.900488 16 2.00049 16H18.0005C19.1005 16 20.0005 15.1 20.0005 14V2C20.0005 0.9 19.1005 0 18.0005 0ZM17.6005 4.25L10.5305 8.67C10.2105 8.87 9.79049 8.87 9.47049 8.67L2.40049 4.25C2.30022 4.19371 2.21241 4.11766 2.14238 4.02645C2.07235 3.93525 2.02155 3.83078 1.99306 3.71937C1.96458 3.60796 1.95899 3.49194 1.97664 3.37831C1.9943 3.26468 2.03482 3.15581 2.09577 3.0583C2.15672 2.96079 2.23681 2.87666 2.33121 2.811C2.42562 2.74533 2.53236 2.69951 2.64498 2.6763C2.75761 2.65309 2.87377 2.65297 2.98644 2.67595C3.09911 2.69893 3.20595 2.74453 3.30049 2.81L10.0005 7L16.7005 2.81C16.795 2.74453 16.9019 2.69893 17.0145 2.67595C17.1272 2.65297 17.2434 2.65309 17.356 2.6763C17.4686 2.69951 17.5754 2.74533 17.6698 2.811C17.7642 2.87666 17.8443 2.96079 17.9052 3.0583C17.9662 3.15581 18.0067 3.26468 18.0243 3.37831C18.042 3.49194 18.0364 3.60796 18.0079 3.71937C17.9794 3.83078 17.9286 3.93525 17.8586 4.02645C17.7886 4.11766 17.7008 4.19371 17.6005 4.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.79be15d7983e2030cfe9d8913fe6b36c.svg";
export { ForwardRef as ReactComponent };